import { Command } from '@/app/common/base/command'

export class CreateDamageReportCommand extends Command {
    public async run(data: FormData, generalInsuranceId: string) {
        await this.client.multiPart(`/api/products/general-insurances/${generalInsuranceId}/damage-reports`, data)
    }
}
